import { render, staticRenderFns } from "./refereeAppointment.vue?vue&type=template&id=5cede7ee&scoped=true"
import script from "./refereeAppointment.vue?vue&type=script&lang=js"
export * from "./refereeAppointment.vue?vue&type=script&lang=js"
import style0 from "./refereeAppointment.vue?vue&type=style&index=0&id=5cede7ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cede7ee",
  null
  
)

export default component.exports